import React, { useEffect, useState } from "react";
import { CustomContainer } from "../../components/BasicComponents";
import "./styles/CurrentUsage.css";
import styled from "styled-components";
import { getUserToken } from "../../utils/userAuthenticate";
import instance from "../../axios";
import { formatStoreCurrency, isIndia } from "../../assets/currency";
import { useTranslation } from "react-i18next";
import "../../localisation/index"
const TextElement = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => align || ""};
  margin: 10px 0px;
  color: ${(props) => (props.$fade ? "#00000099" : "#000000")};
`;

const CurrentUsages = () => {
  const {t} = useTranslation()
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // fetch card data
  const updateData = async () => {
    setIsLoading(true);
    const url = "billing/current/uses";
    const headers = {
      Authorization: getUserToken(),
    };

    try {
      const res = await instance.get(url, { headers });
      const resData = await res.data;
      setData(resData.data);
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    updateData();
  }, []);

  return (
    <div className="transaction-detail__container">
      <div className="component-primary-heading">{t("dashboardMenu.currentUsage")}</div>

      {data?.length > 0 ? (
        data?.reverse().map((uses, index) => {
          return (
            <div key={uses?.id}>
              <div className="section-box-container">
                {/* <div className="transaction-detail__detail-heading"> */}
                {index === 0 ? t("currentUsage.currentPlan") : t("currentUsage.previousPlan")}{" : "}
                {uses?.planName || t("commonTexts.na")}
              </div>

              {/* expected charges */}
              <div className="transaction-detail__plan-fees transaction-detail__box-bg">
                <div className="transaction-detail__detail-heading">
                  Expected Charges - {getNextMonth(uses?.issue_date)}
                  {/* {uses?.planEndDate ? formatDate(uses?.planEndDate) : ""} */}
                </div>

                <div className="gift-card__text-box-container">
                  <div className="gift-card__text-box">
                    <TextElement>{t("currentUsage.subscriptionFee")}</TextElement>
                  </div>
                  <div className="gift-card__text-box">
                    <TextElement align="left">                  
                      {uses?.montly_charge
                        ? formatStoreCurrency(parseFloat(uses?.montly_charge))
                        : t("commonTexts.nill")}
                    </TextElement>
                  </div>
                </div>

                <div className="gift-card__text-box-container">
                  <div className="gift-card__text-box">
                    <TextElement>
                      {t("currentUsage.usageFee", {value: uses?.usage_charge })}
                    </TextElement>
                  </div>
                  <div className="gift-card__text-box">
                    <TextElement align="left">
                      {parseFloat(uses?.used_credit) >
                      parseFloat(uses?.given_credit)
                        ? formatStoreCurrency((
                            ((parseFloat(uses?.used_credit) -
                              parseFloat(uses?.given_credit)) *
                              parseFloat(uses?.usage_charge)) /
                            100
                          ))
                        : formatStoreCurrency(0)}
                    </TextElement>
                  </div>
                </div>

                <div className="gift-card__text-box-container">
                  <TextElement align="right">Total</TextElement>
                  <div className="gift-card__text-box">
                    <TextElement align="left" id="total" className={isIndia() ? t("commonTexts.gst") : t("commonTexts.noContent")}>
                      {formatStoreCurrency(parseFloat(
                        parseFloat(uses?.montly_charge) +
                          (parseFloat(uses?.used_credit) >
                          parseFloat(uses?.given_credit)
                            ? formatStoreCurrency(parseFloat(
                                ((parseFloat(uses?.used_credit) -
                                  parseFloat(uses?.given_credit)) *
                                  parseFloat(uses?.usage_charge)) /
                                  100
                              ))
                            : formatStoreCurrency(parseFloat("00.00")))
                      ))}
                    </TextElement>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="no-element">{t("currentUsage.notAvailable")}</div>
      )}
    </div>
  );
};

export default CurrentUsages;

const formatDate = (dtObj, dt) => {
  const date = new Date(dtObj);
  const monthAr = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  if (dt === "fullDate") {
    return `${
      monthAr[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
  }
  return `${monthAr[date.getMonth()]}, ${date.getFullYear()}`;
};
const getNextMonth = (dtObj) => {
  const date = new Date(dtObj);
  const monthAr = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthAr[date.getMonth() + 1];
};
